import { ReadOnlyModel } from 'core/models/readOnly.model.js';

export var ProfilutilisateurWorkflow = ReadOnlyModel.extend({

});
